'use client';

import classes from "./skeleton.module.css";

// shimmering placeholder block, native-app-only loading states
export default function Skeleton({ width, height, radius, className = "", style = {} }) {
    return <div
        className={`${classes.skeleton} ${className}`}
        style={{ width, height, borderRadius: radius, ...style }}
    />;
}
